import { transport } from 'config/transport';

export function callApiGetCongDoanReportForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/report/congdoan/data-annually`, { params: { academicYear } });
}
